module.exports = __webpack_public_path__ + "static/media/icon-leaf.3a79d5ff.png";